import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  AfterViewChecked,
  ViewChild,
  HostListener,
  ElementRef,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { PotentialPerRegionMapComponent } from '../../pages/national/components/potential-per-region-map/potential-per-region-map.component';
import { HeatmapInclusionProcessComponent } from '../../pages/national/components/heatmap-inclusion-process/heatmap-inclusion-process.component';
import { RegionalAccessActivityPlanTableComponent } from '../../pages/national/components/regional-access-activity-plan-table/regional-access-activity-plan-table.component';
import { OpenToAccessCurveComponent } from '../../pages/national/components/open-to-access-curve/open-to-access-curve.component';
import { OpenToMarketCurveComponent } from '../../pages/national/components/open-to-market-curve/open-to-market-curve.component';
import { MapOpenToAccessRegionsComponent } from '../../pages/national/components/map-open-to-access-regions/map-open-to-access-regions.component';
import { Tooltip } from 'flowbite';
import type { TooltipOptions, TooltipInterface } from 'flowbite';
import type { InstanceOptions } from 'flowbite';
import { EvolutionRegionalAccessComponent } from '../../pages/national/components/evolution-regional-access/evolution-regional-access.component';
import { MonitoringForecastVsActualRegionalLevelComponent } from '../../pages/national/components/monitoring-forecast-vs-actual-regional-level/monitoring-forecast-vs-actual-regional-level.component';
import { NtForecastTimeProgressComponent } from '../../pages/national/components/nt-forecast-time-progress/nt-forecast-time-progress.component';
import { GenerateExcelComponent } from '../../pages/national/components/generate-excel/generate-excel.component';
import { LoadingGenerationComponent } from '../../pages/national/components/loading-generation/loading-generation.component';
import { NHospitalsAndExperiencesComponent } from '../../pages/national/components/n-hospitals-and-experiences/n-hospitals-and-experiences.component';
import { EvolutionRegionalMarketComponent } from '../../pages/national/components/evolution-regional-market/evolution-regional-market.component';
import { MapForecastCompleteAccessComponent } from '../../pages/national/components/map-forecast-complete-access/map-forecast-complete-access.component';
import { MonitoringCompleteAccessComponent } from '../../pages/national/components/monitoring-complete-access/monitoring-complete-access.component';
import { MonitoringAggiudicazioneComponent } from '../../pages/national/components/monitoring-aggiudicazione/monitoring-aggiudicazione.component';
import { InclusionProcessToolNationalComponent } from '../../pages/national/components/inclusion-process-tool-national/inclusion-process-tool-national.component';
import { UserService } from '../../../../services/users/user.service';
import { TooltipsInterface } from '../../../../shared/interfaces/nt-tooltips';
import { HeatmapEconomiaComponent } from '../../pages/national/components/heatmap-economia/heatmap-economia.component';
import { OpenToEconomiaCurveComponent } from '../../pages/national/components/open-to-economia-curve/open-to-economia-curve.component';
import { ForecastAccuracyOpenToAccessComponent } from '../../pages/national/components/forecast-accuracy-open-to-access/forecast-accuracy-open-to-access.component';
import { ForecastAccuracyOpenToEconomiaComponent } from '../../pages/national/components/forecast-accuracy-open-to-economia/forecast-accuracy-open-to-economia.component';
import { ForecastAccuracyOpenToMarketComponent } from '../../pages/national/components/forecast-accuracy-open-to-market/forecast-accuracy-open-to-market.component';
import { EvolutionRegionalEconomiaComponent } from '../../pages/national/components/evolution-regional-economia/evolution-regional-economia.component';
import { GenerateHospitalsAndExperiencesExcelComponent } from '../../pages/national/components/generate-hospitals-and-experiences-excel/generate-hospitals-and-experiences-excel.component';
import { MergedHeatmapComponent } from '../../pages/national/components/merged-heatmap/merged-heatmap.component';
import { NtPotentialRegionInterface } from '../../../../shared/interfaces/nt-potential-region.interface';
import { OpenToMarketCurve30DaysComponent } from '../../pages/national/components/open-to-market-curve-30-days/open-to-market-curve-30-days.component';
import { CustomizableHeatmapOpenToMarketComponent } from '../../pages/national/components/customizable-heatmap-open-to-market/customizable-heatmap-open-to-market.component';
import { WIDGET_LAYOUT } from '../../../../shared/interfaces/widgetLayout';
import { NtMedicineInterface } from '../../../../shared/interfaces/nt-medicine.interface';
import { EvolutionRegionalMarket30DaysComponent } from '../../pages/national/components/evolution-regional-market-30-days/evolution-regional-market-30-days.component';
import { AlternativeWidgetsNameInterface } from '../../../../shared/interfaces/nt-AlternativeWidgetsName';
import { ALTERNATIVE_WIDGETS_NAME_NT } from '../../../../shared/data/alternativeWidgetsName.data';
import { OpenToMarketCurve30DaysMergedComponent } from '../../pages/national/components/open-to-market-curve-30-days-merged/open-to-market-curve-30-days-merged.component';

@Component({
  selector: 'app-card-widget',
  standalone: true,
  imports: [
    CommonModule,
    PotentialPerRegionMapComponent,
    HeatmapInclusionProcessComponent,
    RegionalAccessActivityPlanTableComponent,
    OpenToAccessCurveComponent,
    OpenToMarketCurveComponent,
    MapOpenToAccessRegionsComponent,
    EvolutionRegionalAccessComponent,
    MonitoringForecastVsActualRegionalLevelComponent,
    NtForecastTimeProgressComponent,
    GenerateExcelComponent,
    LoadingGenerationComponent,
    NHospitalsAndExperiencesComponent,
    EvolutionRegionalMarketComponent,
    MapForecastCompleteAccessComponent,
    MonitoringCompleteAccessComponent,
    MonitoringAggiudicazioneComponent,
    InclusionProcessToolNationalComponent,
    HeatmapEconomiaComponent,
    OpenToEconomiaCurveComponent,
    ForecastAccuracyOpenToAccessComponent,
    ForecastAccuracyOpenToEconomiaComponent,
    ForecastAccuracyOpenToMarketComponent,
    EvolutionRegionalEconomiaComponent,
    GenerateHospitalsAndExperiencesExcelComponent,
    MergedHeatmapComponent,
    OpenToMarketCurve30DaysComponent,
    EvolutionRegionalMarket30DaysComponent,
    OpenToMarketCurve30DaysMergedComponent,
    CustomizableHeatmapOpenToMarketComponent
  ],
  templateUrl: './card-widget.component.html',
  styleUrl: './card-widget.component.css',
})
export class CardWidgetComponent implements OnInit, AfterViewChecked {
  @ViewChild('tooltipButton') tooltipButton!: ElementRef;
  @Input() title = '';
  @Input() className = '';
  @Input() isEdit: boolean = false;
  @Input() widgetId!: number;
  // user's title choice from the parent: true = default (company) name, false = alternative name
  @Input() isDefaultName: boolean = true;
  @Input() extendWidget: boolean = false;
  @Input() isDrag: boolean = false;
  @Input() tooltipInfo?: TooltipsInterface;
  @Input() widgetsAvailable: WIDGET_LAYOUT[] = [];
  @Input() medicineInfoData: NtMedicineInterface = {
      id: 0,
      businessName: '',
      creationDate: '',
      activeSubstance: '',
      therapeuticArea: '',
      therapeuticIndication: '',
      therapeuticIndicationAcronym: '',
      reimbursementClass: '',
      supplyClass: '',
      atc: '',
      aic: '',
      openToAccessType: '',
      medicineBrandInfo: {
        font: { title: '', subtitle: '' },
        colors: { title: '', subtitle: '', background: '' },
        logo: { url: '', altText: 'Logo' },
      },
      launched: false,
      imported: false,
      tags: [],
      active: false,
    };

  @Output() deleteWidget = new EventEmitter<number>();
  // emits the chosen isDefaultName (true = default name, false = alternative name)
  @Output() titleSelected = new EventEmitter<boolean>();
  @Output() openModalAddActivities = new EventEmitter<boolean>();
  @Output() openAccessCurve = new EventEmitter<boolean>();
  @Output() openMarketCurve = new EventEmitter<boolean>();
  @Output() openEconomiaCurve = new EventEmitter<boolean>();

  deleteModalOpen: boolean = false;

  private tooltipsInitialized = false;

  // for evoluzione widget
  isEvoluzioneTwoRowsLayout: boolean = false;

  heatmapColor: 'Red' | 'White' = 'Red';
  heatmapRegionalInclusionColor: 'Red' | 'White' = 'Red';
  heatmapEconomiaColor: 'Red' | 'White' = 'White';
  mergedHeatmapData: NtPotentialRegionInterface[] = [];

  generateExcel: boolean = false;
  canGenerateExcel: boolean = false; // this will take value from the output of the loading pop up
  hasCurveDataToShowReportButton = false;
  @ViewChild(LoadingGenerationComponent)
  loadingComponent!: LoadingGenerationComponent;
  tooltipVisible = false;
  generateHospitalsExcel: boolean = false;
  isMergedHeatmapVisible: boolean = false;
  isMergedHeatmapEconomiaVisible: boolean = false;

  titleDropdownOpen: boolean = false;
  alternativeTitle: string = '';

  // Selected title comes from the parent (saved in the user preferences).
  // Widgets without an alternative title always use the default name.
  get selectedTitleOption(): 'first' | 'second' {
    return this.isDefaultName === false && this.alternativeTitle !== '' ? 'second' : 'first';
  }

  // Title shown in and outside edit mode
  get displayedTitle(): string {
    return this.selectedTitleOption === 'second' ? this.alternativeTitle : this.title;
  }

  constructor(private userService: UserService) {}

  openModalDelete(status: boolean) {
    this.deleteModalOpen = status;
    if (this.deleteModalOpen) {
      document.body.style.overflow = 'hidden';
      document.body.style.width = '100%';
    } else {
      document.body.style.overflow = '';
      document.body.style.width = '';
    }
  }

  onDelete() {
    this.deleteWidget.emit(this.widgetId);
    document.body.style.overflow = '';
    document.body.style.width = '';
  }

  ngOnInit(): void {
    if (this.className == 'widget-heatmap') {
      this.heatmapColor =
        (sessionStorage.getItem('heatmapColor') as 'Red' | 'White') || 'Red';
    }
    if (this.className == 'widget-mapOpenAccess') {
      this.heatmapRegionalInclusionColor =
        (sessionStorage.getItem('heatmapRegionalInclusionColor') as
          | 'Red'
          | 'White') || 'Red';
    }

    if (this.className == 'widget-heatmap-economia') {
      this.heatmapEconomiaColor =
        (sessionStorage.getItem('heatmapEconomiaColor') as 'Red' | 'White') ||
        'White';
    }
    
    this.alternativeTitle =
  ALTERNATIVE_WIDGETS_NAME_NT.find(w => w.id === this.widgetId)?.text ?? '';
  
    this.tooltipConfig();
  }

  ngAfterViewChecked(): void {
    const triggers = document.querySelectorAll('.tooltip-trigger');
    const contents = document.querySelectorAll('.tooltip-content');

    // if not visible tooltips reset the flag
    if (triggers.length === 0 || contents.length === 0) {
      this.tooltipsInitialized = false;
    }

    if (!this.tooltipsInitialized && triggers.length && contents.length) {
      this.tooltipConfig();
      this.tooltipsInitialized = true;
    }
  }

  tooltipConfig(): void {
    const triggerElements =
      document.querySelectorAll<HTMLElement>('.tooltip-trigger');
    const contentElements =
      document.querySelectorAll<HTMLElement>('.tooltip-content');

    triggerElements.forEach((triggerEl, index) => {
      const contentEl = contentElements[index];

      if (contentEl && triggerEl) {
        const options: TooltipOptions = {
          placement: 'top',
          triggerType: 'hover',
          /*   onHide: () => console.log('tooltip is hidden'),
          onShow: () => console.log('tooltip is shown'),
          onToggle: () => console.log('tooltip is toggled'),*/
        };

        const instanceOptions: InstanceOptions = {
          id: `tooltip-${index}`,
          override: true,
        };

        new Tooltip(contentEl, triggerEl, options, instanceOptions);
      }
    });
  }
  

  openModalAddActivity(value: boolean) {
    this.openModalAddActivities.emit(value);
  }

  openAccessCurveFromChild(isAccessCurveOpen: boolean) {
    this.openAccessCurve.emit(isAccessCurveOpen);
  }

  openEconomiaCurveFromChild(isEconomiaCurveOpen: boolean) {
    this.openEconomiaCurve.emit(isEconomiaCurveOpen);
  }

  openMarketCurveFromChild(isMarketCurveOpen: boolean) {
    this.openMarketCurve.emit(isMarketCurveOpen);
  }

  getTooltipWidthClass(): string {
    const screenWidth = window.innerWidth;
    const isSmallScreen = screenWidth < 1280;
    const isBigScreen = screenWidth > 1910;

    if (isSmallScreen) {
      return 'w-[140px]';
    }

    if (isBigScreen) {
      switch (this.tooltipInfo?.className) {
        case 'widget-esperienze-map':
          return 'w-[190px]';
        case 'widget-heatmap':
          return 'w-[205px]';
        case 'widget-mapOpenAccess':
          return 'w-[205px]';
        case 'widget-curva-accesso':
          return 'w-[210px]';
        case 'widget-curva-mercato':
          return 'w-[210px]';
        case 'widget-evolution-regional-access':
          return 'w-[205px]';
        case 'widget-evolution-regional-market':
          return 'w-[205px]';
        case 'widget-evolution-regional-market-30-days':
          return 'w-[205px]';
        case 'widget-monitoringForecastVsActualRegionalLevel':
          return 'w-[205px]';
        case 'widget-forecastTimeProgress':
          return 'w-[205px]';
        case 'widget-attivita':
          return 'w-[205px]';
        case 'widget-map-forecast-complete-access':
          return 'w-[205px]';
        case 'widget-inclusion-process-tool-national':
          return 'w-[205px]';
        case 'widget-heatmap-economia':
          return 'w-[205px]';
        default:
          return 'w-[205px]';
      }
    }

    // Schermi medi (1280px - 1910px)
    switch (this.tooltipInfo?.className) {
      case 'widget-esperienze-map':
        return 'w-[160px]';
      case 'widget-heatmap':
        return 'w-[185px]';
      case 'widget-mapOpenAccess':
        return 'w-[175px]';
      case 'widget-curva-accesso':
        return 'w-[180px]';
      case 'widget-curva-mercato':
        return 'w-[180px]';
      case 'widget-evolution-regional-access':
        return 'w-[175px]';
      case 'widget-evolution-regional-market':
        return 'w-[175px]';
         case 'widget-evolution-regional-market-30-days':
        return 'w-[175px]';
      case 'widget-monitoringForecastVsActualRegionalLevel':
        return 'w-[175px]';
      case 'widget-forecastTimeProgress':
        return 'w-[175px]';
      case 'widget-attivita':
        return 'w-[175px]';
      case 'widget-map-forecast-complete-access':
        return 'w-[175px]';
      case 'widget-inclusion-process-tool-national':
        return 'w-[175px]';
      case 'widget-heatmap-economia':
        return 'w-[205px]';
      default:
        return 'w-[175px]';
    }
  }

  generateReport(status: boolean) {
    this.generateExcel = status;
    document.body.style.overflow = 'hidden';
    document.body.style.width = '100%';
    setTimeout(() => {
      this.canGenerateExcel = true;
    }, 2000);
  }

  onEndMessage(event: Event) {
    this.loadingComponent.endingMessage();
    setTimeout(() => {
      this.generateExcel = false;
      this.canGenerateExcel = false;
      document.body.style.overflow = '';
      document.body.style.width = '';
    }, 1000);
  }

  onToggleHeatmapHospitalsChange(event: Event) {
    const input = event.target as HTMLInputElement;
    this.heatmapColor = input.checked ? 'White' : 'Red';
    sessionStorage.setItem('heatmapColor', this.heatmapColor);
    this.saveHeatmapColorPreference();
  }

  onToggleHeatmapRegionalInclusionChange(event: Event) {
    const input = event.target as HTMLInputElement;
    this.heatmapRegionalInclusionColor = input.checked ? 'White' : 'Red';
    sessionStorage.setItem(
      'heatmapRegionalInclusionColor',
      this.heatmapRegionalInclusionColor,
    );
    this.saveHeatmapRegionalInclusionColorPreference();
  }

  saveHeatmapColorPreference(): void {
    const username = sessionStorage.getItem('username') || '';
    const companyId = sessionStorage.getItem('companyId');
    const payload = {
      username: username,
      companyId: companyId,
      heatmapColor: this.heatmapColor,
    };

    this.userService.updateUserPreferences(payload).subscribe({
      next: () => {
        // console.log('Preferences saved');
      },
      error: (err) => console.error('Save failed', err),
    });
  }

  saveHeatmapRegionalInclusionColorPreference(): void {
    const username = sessionStorage.getItem('username') || '';
    const companyId = sessionStorage.getItem('companyId');
    const payload = {
      username: username,
      companyId: companyId,
      heatmapRegionalInclusionColor: this.heatmapRegionalInclusionColor,
    };

    this.userService.updateUserPreferences(payload).subscribe({
      next: () => {
        // console.log('Preferences saved');
      },
      error: (err) => console.error('Save failed', err),
    });
  }

  onToggleHeatmapEconomiaChange(event: Event) {
    const input = event.target as HTMLInputElement;
    this.heatmapEconomiaColor = input.checked ? 'White' : 'Red';
    sessionStorage.setItem('heatmapEconomiaColor', this.heatmapEconomiaColor);
    this.saveHeatmapEconomiaColorPreference();
  }

  saveHeatmapEconomiaColorPreference(): void {
    const username = sessionStorage.getItem('username') || '';
    const companyId = sessionStorage.getItem('companyId');
    const payload = {
      username: username,
      companyId: companyId,
      heatmapEconomiaColor: this.heatmapEconomiaColor,
    };
    this.userService.updateUserPreferences(payload).subscribe({
      next: () => {
        // console.log('Preferences saved');
      },
      error: (err) => console.error('Save failed', err),
    });
  }

  checkIfCurveHasData(hasData: boolean): void {
    this.hasCurveDataToShowReportButton = hasData;
  }

  // the three following functions handle the tooltip opening and closing on tablets/mobile
  toggleTooltip() {
    if (this.isTouchDevice()) {
      this.tooltipVisible = !this.tooltipVisible;
    }
  }

  // detects if the device supports touch input
  isTouchDevice(): boolean {
    return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  }


  // triggers the hospitals and experiences excel generation flow
  generateHospitalsReport (): void {
    this.generateHospitalsExcel = true;
  }

  // called when hospitals excel generation completes
  onEndHospitalsMessage (): void {
    this.generateHospitalsExcel = false;
  }

  // closes the tooltip if the user clicks anywhere outside the button
  @HostListener('document:click', ['$event'])
  handleClickOutside(event: Event) {
    // the tooltip button is not rendered in edit mode
    if (!this.tooltipButton?.nativeElement) {
      return;
    }
    if (!this.tooltipButton.nativeElement.contains(event.target)) {
      this.tooltipVisible = false;
    }
  }

  onEconomiaDataLoaded(data: NtPotentialRegionInterface[]): void {
    this.mergedHeatmapData = data;
  }

    mergedHeatmapStatusChange(isVisible: boolean): void {
    this.isMergedHeatmapVisible = isVisible;
    if(this.isMergedHeatmapVisible) {
      document.body.style.overflow = 'hidden';
      document.body.style.width = '100%';
    } else {
      document.body.style.overflow = '';
      document.body.style.width = '';
    }
  }

  mergedHeatmapEconomiaStatusChange(isVisible: boolean): void {
    this.isMergedHeatmapEconomiaVisible = isVisible;
    if(this.isMergedHeatmapEconomiaVisible) {
      document.body.style.overflow = 'hidden';
      document.body.style.width = '100%';
    } else {
      document.body.style.overflow = '';
      document.body.style.width = '';
    }
  }

    toggleTitleDropdown(): void {
    this.titleDropdownOpen = !this.titleDropdownOpen;
  }

  closeTitleDropdown(): void {
    this.titleDropdownOpen = false;
  }

  selectTitleOption(option: 'first' | 'second'): void {
    this.titleDropdownOpen = false;
    if (option !== this.selectedTitleOption) {
      // the parent updates isDefaultName and saves the preference
      this.titleSelected.emit(option === 'first');
    }
  }
}
